var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React, { PureComponent } from 'react';
import Dialog from './dialog';
import { DefaultButton, RedButton } from './buttons';
var CancelDialog = /** @class */function (_super) {
  __extends(CancelDialog, _super);
  function CancelDialog() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.handleSubmit = function (e) {
      var onConfirm = _this.props.onConfirm;
      e.preventDefault();
      onConfirm();
    };
    _this.handleEsc = function (e) {
      var onConfirm = _this.props.onConfirm;
      // Esc key
      if (e.keyCode === 27) {
        onConfirm();
      }
    };
    return _this;
  }
  CancelDialog.prototype.render = function () {
    var _a = this.props,
      innerRef = _a.innerRef,
      onBack = _a.onBack,
      title = _a.title,
      content = _a.content,
      preferencesDialogTemplate = _a.preferencesDialogTemplate;
    var buttons = React.createElement("div", null, React.createElement(DefaultButton, {
      type: "button",
      onClick: onBack
    }, preferencesDialogTemplate === null || preferencesDialogTemplate === void 0 ? void 0 : preferencesDialogTemplate.cancelDialogButtons.backValue), React.createElement(RedButton, {
      type: "submit"
    }, preferencesDialogTemplate === null || preferencesDialogTemplate === void 0 ? void 0 : preferencesDialogTemplate.cancelDialogButtons.cancelValue));
    return React.createElement(Dialog, {
      innerRef: innerRef,
      title: title,
      buttons: buttons,
      onSubmit: this.handleSubmit,
      width: "500px"
    }, content);
  };
  CancelDialog.prototype.componentDidMount = function () {
    document.body.addEventListener('keydown', this.handleEsc, false);
  };
  CancelDialog.prototype.componentWillUnmount = function () {
    document.body.removeEventListener('keydown', this.handleEsc, false);
  };
  CancelDialog.displayName = 'CancelDialog';
  return CancelDialog;
}(PureComponent);
export default CancelDialog;